function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a6.5 6.5 0 0 0-3.788 11.783l.472-1.415A2 2 0 0 1 14.08 19h2.838a2 2 0 0 1 1.897 1.368l.472 1.415A6.5 6.5 0 0 0 15.5 10zm2.91 12.313l-.543-1.63A1 1 0 0 0 16.92 20h-2.84a1 1 0 0 0-.948.684l-.544 1.63a6.48 6.48 0 0 0 2.911.686 6.473 6.473 0 0 0 2.91-.687zM8 16.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0zm5.5-2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V14zm1 0v2.5h2V14h-2z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.eaca6ffd197dcf97734d3c97b12bc4b9.svg";
export { ForwardRef as ReactComponent };